function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { LSCMSUtils } from "../../../cms/engine/assets/js/utils";
var LSCHWeb = {
  currentSearchInput: null,
  initialize: function initialize() {
    var _clientData$emails, _clientData$emails2, _clientData$formData, _clientData$page3, _clientData$page4, _clientData$formData6, _clientData$formData7;
    this.currentSearchInput = (location.hash && location.hash !== '#0' ? location.hash : false) || LSUtils.getQueryStringParameter('company') || LSUtils.getQueryStringParameter('companyName') || null;
    try {
      if (this.currentSearchInput) this.currentSearchInput = decodeURIComponent(this.currentSearchInput);
    } catch (ex) {
      // just in case
    }
    if (this.currentSearchInput) this.currentSearchInput = this.currentSearchInput.replace('#', '');else if ((_clientData$emails = clientData.emails) !== null && _clientData$emails !== void 0 && _clientData$emails.companyNumber) this.currentSearchInput = clientData.emails.companyNumber;else if ((_clientData$emails2 = clientData.emails) !== null && _clientData$emails2 !== void 0 && _clientData$emails2.companyName) this.currentSearchInput = clientData.emails.companyName;
    this.bind();
    var qsParam = LSUtils.getQueryStringParameter('soleTrader');
    var isSoleTrader = !!(qsParam && qsParam === 'true' || (_clientData$formData = clientData.formData) !== null && _clientData$formData !== void 0 && (_clientData$formData = _clientData$formData.type) !== null && _clientData$formData !== void 0 && _clientData$formData.includes('/soleTrader'));
    if (isSoleTrader) {
      // distinct vat reg for example
      var $view = $('.company-id');
      this.renderSoleTrader($view);
    } else {
      var _clientData$page, _clientData$page2, _clientData$formData2, _clientData$formData3, _clientData$formData4, _clientData$formData5;
      if ((((_clientData$page = clientData.page) === null || _clientData$page === void 0 ? void 0 : _clientData$page.type) === 'checkout' || ((_clientData$page2 = clientData.page) === null || _clientData$page2 === void 0 ? void 0 : _clientData$page2.type) === 'ngd-checkout') && !((_clientData$formData2 = clientData.formData) !== null && _clientData$formData2 !== void 0 && (_clientData$formData2 = _clientData$formData2.type) !== null && _clientData$formData2 !== void 0 && _clientData$formData2.includes('/creation')) && !((_clientData$formData3 = clientData.formData) !== null && _clientData$formData3 !== void 0 && (_clientData$formData3 = _clientData$formData3.type) !== null && _clientData$formData3 !== void 0 && _clientData$formData3.includes('/selfAssessmentFiling')) && !((_clientData$formData4 = clientData.formData) !== null && _clientData$formData4 !== void 0 && (_clientData$formData4 = _clientData$formData4.type) !== null && _clientData$formData4 !== void 0 && _clientData$formData4.includes('/utrRegistration')) && !((_clientData$formData5 = clientData.formData) !== null && _clientData$formData5 !== void 0 && (_clientData$formData5 = _clientData$formData5.type) !== null && _clientData$formData5 !== void 0 && _clientData$formData5.includes('/cisRegistration'))) {
        //if (this.currentSearchInput)
        //this.searchModal(this.currentSearchInput);
        //else

        if (!this.currentSearchInput) this.showSearchInput("");
      }
    }
    if ((((_clientData$page3 = clientData.page) === null || _clientData$page3 === void 0 ? void 0 : _clientData$page3.type) === 'checkout' || ((_clientData$page4 = clientData.page) === null || _clientData$page4 === void 0 ? void 0 : _clientData$page4.type) === 'ngd-checkout') && (((_clientData$formData6 = clientData.formData) === null || _clientData$formData6 === void 0 ? void 0 : _clientData$formData6.type) === '/forms/company/hmrc/vatRegistration' || ((_clientData$formData7 = clientData.formData) === null || _clientData$formData7 === void 0 ? void 0 : _clientData$formData7.type) === '/forms/company/hmrc/vatReturn')) {
      this.saveBusinessType(isSoleTrader);
    }
  },
  bind: function bind() {
    var self = this;
    // $('.form-ch-search').on('submit', function () {
    $(document).on('submit', '.form-ch-search', function () {
      self.onSearchFormCTAClick($(this));
      return false;
    });
    var chfeepopup = false;
    $(document).on('click', '.ch-fee-link', function () {
      var $img = $('<img src="' + LSUtils.url() + '/cms/data/content/common/img/ch-fees.png" class="w-100"/>');
      if (!chfeepopup) {
        chfeepopup = true;
        BootstrapDialog.show({
          closable: true,
          fullscreen: false,
          size: BootstrapDialog.SIZE_WIDE,
          title: 'Companies House Fee Increase Notice',
          message: $img,
          onhide: function onhide() {
            chfeepopup = false;
          }
        });
      }
      return false;
    });
  },
  // load json api
  loadJsonAPI: function loadJsonAPI(companyNumber) {
    var dfd = $.Deferred();
    $.ajax({});
    return dfd.promise();
  },
  // SEARCHES

  // USE CASE 1
  // company search form on home/product pages
  // assuming form.action already set to correct url
  // adding company name as query string param to form.action
  onSearchFormCTAClick: function onSearchFormCTAClick($form) {
    var companyNameOrNumber = encodeURIComponent($('input', $form).val());
    var redirectUrl = null;
    if ($form.attr('action') !== '#') {
      redirectUrl = $form.attr('action') + ($form.attr('action').includes("?") ? '&company=' : '?company=') + companyNameOrNumber;
    } else {
      var _clientData$page5;
      redirectUrl = clientData.pagePath === '/' || clientData.pagePath.includes('/creation') || ((_clientData$page5 = clientData.page) === null || _clientData$page5 === void 0 ? void 0 : _clientData$page5.type) === 'search' || clientData.pagePath === '/company/' ? /* test of new ltd page under /company/creation/page.json */
      LSUtils.url() + '/company/search/?company=' + companyNameOrNumber : LSUtils.url() + clientData.pagePath + 'checkout/?company=' + companyNameOrNumber;
    }
    var optionId = LSUtils.getQueryStringParameter('optionId');
    var rank = LSUtils.getQueryStringParameter('rank');
    if (optionId) {
      redirectUrl += '&optionId=' + optionId;
    }
    if (rank) {
      redirectUrl += '&rank=' + rank;
    }
    $form.addClass('was-validated');
    if ($form[0].checkValidity()) {
      $('button i', $form).hide();
      var btn = Ladda.create($('button', $form)[0]);
      btn.start();
      setTimeout(function () {
        btn.stop();
        $('button i', $form).show();
      }, 2000);
      window.location.href = redirectUrl;
    }
  },
  // USE CASE 2
  // used on search result page
  searchPage: function searchPage(companyName) {
    var self = this;
    var input = companyName;
    if (!input) {
      var _input;
      input = location.hash || LSUtils.getQueryStringParameter('company') || LSUtils.getQueryStringParameter('companyName');
      // input = decodeURIComponent(input).replace('#', '');
      try {
        input = decodeURIComponent(input);
      } catch (ex) {
        // just in case
      }
      input = (_input = input) === null || _input === void 0 ? void 0 : _input.replace('#', '');
    }
    if (!input) return;
    this.currentSearchInput = input;

    // name check
    $.ajax({
      url: LSUtils.url() + "/app/services/companyHouseJSON",
      data: {
        cmd: 'nameCheck',
        param: input,
        clientId: clientData.clientId
      }
    }).done(function (chAvail) {
      try {
        chAvail = JSON.parse(chAvail);
        if (chAvail.data.validation === 'false') {
          // exists in CH register
          //  name search {coNumber}
          //      render card
          var $html = $(decodeURIComponent(chAvail.data.message).replace(/\+/g, " "));
          var coNumber = self.extractCoNumberFromNameCheckResponse($html);
          $.ajax({
            url: LSUtils.url() + "/app/services/companyHouseJSON",
            data: {
              cmd: 'nameSearch',
              param: coNumber
            }
          }).done(function (chSearch) {
            try {
              chSearch = JSON.parse(chSearch);
              chSearch = chSearch.data.length ? JSON.parse(chSearch.data[0]) : {
                items: [],
                total_results: 0
              };
              // render card
              self.renderSearch(chSearch, chAvail, input);
            } catch (ex) {
              self.onSearchPageError(self.currentSearchInput, chSearch);
            }
          });
        } else {
          // no close name found, avail to regster!
          var chSearch = {
            items: [],
            total_results: 0
          };
          self.renderSearch(chSearch, chAvail, input);
        }
      } catch (ex) {
        self.onSearchPageError(self.currentSearchInput, chAvail);
      }

      // not used anymore on the page
      // name search {coName}
      //      render results
      // $.ajax({
      //     url: LSUtils.url() + "/app/services/companyHouseJSON",
      //     data: {
      //         cmd: 'nameSearch',
      //         param: input
      //     }
      // }).done(function (chSearch) {
      //     try {
      //         chSearch = JSON.parse(chSearch);
      //         chSearch = chSearch?.data?.length ? JSON.parse(chSearch.data[0]) : {items: [], total_results: 0};
      //     } catch (ex) {
      //         chSearch = {items: [], total_results: 0};
      //     }
      //     // render search results
      //     self.renderSearchPageResults(chSearch);
      // });
    });
  },
  // USE CASE 3
  // used mainly on checkout pages (conf, change, hmrc etc)
  maxRetrySearch: 3,
  retrySearch: 0,
  delayRetry: 500,
  searchModal: function searchModal(companyName) {
    var popupCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var self = this;
    var dfd = $.Deferred();
    $.ajax({
      url: LSUtils.url() + "/app/services/companyHouseJSON",
      data: {
        cmd: 'nameSearch',
        param: companyName
      },
      success: function () {
        var _success = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(response) {
          var j, $view, loop;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                j = JSON.parse(JSON.parse(response).data[0]);
                if (j.total_results === 0) {
                  // no result: company name not found
                  self.showSearchInput(companyName);
                }
                if (!(j.total_results === 1)) {
                  _context.next = 9;
                  break;
                }
                // exactly 1 result
                $view = $('.company-id');
                self.loadCompanyProfile($view, j.items[0]);
                self.foundOne = j.items[0];
                _context.next = 21;
                break;
              case 9:
                if (j.items) {
                  _context.next = 20;
                  break;
                }
                if (!(self.retrySearch < self.maxRetrySearch)) {
                  _context.next = 17;
                  break;
                }
                // let s retry
                self.retrySearch++;
                _context.next = 14;
                return LSUtils.sleep(self.delayRetry);
              case 14:
                return _context.abrupt("return", self.searchModal(companyName, popupCallback));
              case 17:
                // max retry reached - let the user search again
                self.showSearchInput(companyName);
              case 18:
                _context.next = 21;
                break;
              case 20:
                // we have multiple results from ch
                loop = setInterval(function () {
                  if (!$('.modal-backdrop').length) {
                    clearInterval(loop);
                    self.popup = BootstrapDialog.show({
                      closable: false,
                      fullscreen: false,
                      title: 'Search results',
                      message: self.renderSearchResults(j, popupCallback),
                      onshow: function onshow(dialogRef) {
                        dialogRef.getModalBody().css('max-height', '500px');
                        dialogRef.getModalBody().css('overflow', 'scroll');
                      }
                    });
                  }
                }, 500);
              case 21:
                _context.next = 25;
                break;
              case 23:
                _context.prev = 23;
                _context.t0 = _context["catch"](0);
              case 25:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 23]]);
        }));
        function success(_x) {
          return _success.apply(this, arguments);
        }
        return success;
      }()
    });
    return dfd.promise();
  },
  // USE CASE 3.2
  // used on checkout integrated search (conf, change, hmrc etc)
  searchOnly: function searchOnly(companyName) {
    var self = this;
    var dfd = $.Deferred();
    $.ajax({
      url: LSUtils.url() + "/app/services/companyHouseJSON",
      data: {
        cmd: 'nameSearch',
        param: companyName
      },
      success: function () {
        var _success2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(response) {
          var data;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                data = JSON.parse(JSON.parse(response).data[0]);
                if (data.items) {
                  _context2.next = 13;
                  break;
                }
                if (!(self.retrySearch < self.maxRetrySearch)) {
                  _context2.next = 10;
                  break;
                }
                self.retrySearch++;
                _context2.next = 7;
                return LSUtils.sleep(self.delayRetry);
              case 7:
                return _context2.abrupt("return", self.searchModal(companyName, popupCallback));
              case 10:
                // max retry reached - let the user search again
                self.showSearchInput(companyName);
              case 11:
                _context2.next = 14;
                break;
              case 13:
                dfd.resolve(data.items);
              case 14:
                _context2.next = 18;
                break;
              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](0);
              case 18:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[0, 16]]);
        }));
        function success(_x2) {
          return _success2.apply(this, arguments);
        }
        return success;
      }()
    });
    return dfd.promise();
  },
  // USE CASE 4
  // Used when a user attempt to proceed through the funnel before searching for an available name
  nameAvailModal: function nameAvailModal(redirect, qs) {
    var self = this;
    var dfd = $.Deferred();
    self.popup = BootstrapDialog.show({
      size: BootstrapDialog.SIZE_WIDE,
      closable: true,
      fullscreen: false,
      title: 'Your company name',
      message: this.showNameAvailModalContent(redirect, qs)
    });
    return dfd.promise();
  },
  // SEARCH PAGE HELPERS

  renderSearch: function renderSearch(chSearch, chAvail, companyName) {
    var _this = this;
    // keep ref on loading
    this.$loadingView = $('.atf-search-loading');

    // render view
    var $view;
    var delay = 4000;
    if (chAvail.data.validation === 'false') {
      delay = 1000;
      $view = $('.templates .atf-found').clone(true);
      // render card with co data

      this.loadCompanyProfile($view, chSearch.items[0]);

      //LSCMSUtils.gtmPageViewEvent(LSCMSUtils.getAnalyticsPageName() + 'found')
      // google analtyics tracking
      // if (typeof (window.ga) !== 'undefined') {
      //     window.ga('set', 'page', LSCMSUtils.getAnalyticsPageName() + 'found/');
      //     window.ga('send', 'pageview');
      // }
      // // mouseflow tracking
      // if (typeof (window._mfq) !== 'undefined') {
      //     window._mfq.push(["newPageView", LSCMSUtils.getAnalyticsPageName() + 'found/']);
      // }
    } else {
      $view = $('.templates .atf-available').clone(true);
      var $btn = $('.btn', $view);
      if (!$btn.hasClass('btn-questionnaire')) {
        // let s not rewrite the btn href if btn is for creation (unified funnel)
        var checkoutHref = $btn.attr('href');
        $btn.attr('href', checkoutHref + encodeURIComponent(companyName));
      }

      //LSCMSUtils.gtmPageViewEvent(LSCMSUtils.getAnalyticsPageName() + 'available')
      // // google analtyics tracking
      // if (typeof (window.ga) !== 'undefined') {
      //     window.ga('set', 'page', LSCMSUtils.getAnalyticsPageName() + 'available/');
      //     window.ga('send', 'pageview');
      // }
      // // mouseflow tracking
      // if (typeof (window._mfq) !== 'undefined') {
      //     window._mfq.push(["newPageView", LSCMSUtils.getAnalyticsPageName() + 'available/']);
      // }
    }

    // set co name
    var name = chAvail.data.name;
    try {
      name = decodeURIComponent(name);
    } catch (ex) {
      // just in case
    }
    var endingsArr = ['ltd', 'ltd.', 'limited'];
    name = name.toLowerCase();
    for (var _i = 0, _endingsArr = endingsArr; _i < _endingsArr.length; _i++) {
      var e = _endingsArr[_i];
      if (name.includes(e)) name = name.replace(e, '');
    }
    if (name.toLowerCase().includes('limited')) name = name.toLowerCase().replace('limited', '');
    if (name.toLowerCase().includes('ltd.')) name = name.toLowerCase().replace('ltd.', '');
    if (name.toLowerCase().includes('ltd')) name = name.toLowerCase().replace('ltd', '');
    $('.search-company-name', $view).html(name.toUpperCase());
    this.currentSearchInput = name.toUpperCase();

    // replace loading view with result view
    // give time to the user to see searching animation
    setTimeout(function () {
      _this.$loadingView.replaceWith($view);
      setTimeout(function () {
        $view.css({
          opacity: 1
        });
        if (chAvail.data.validation !== 'false') {
          LSCMSUtils.confetti();
          if (typeof atfAvailable !== 'undefined') atfAvailable.initialize();
        }
      }, 100);
    }, delay);
  },
  renderSearchPageResults: function renderSearchPageResults(chSearch) {
    // render search results
    $('.container-search-results .total-results').html(chSearch.total_results);
    if (chSearch.total_results === 0) {
      var $noRes = $('.templates .no-res');
      $('.container-search-results .loading').replaceWith($noRes);
    } else {
      $('#search-results-no-res').hide();
      var $results = this.renderSearchResultsItems(chSearch);
      $('.container-search-results .loading').replaceWith($results);
    }
  },
  loadCompanyProfile: function () {
    var _loadCompanyProfile = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3($view, company) {
      var _clientData$formData8, self, data, timestampNextConf, timestampToday;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            $('.item-loader-wrapper').show();
            $('.company-id-header').hide();
            $('#details-list').empty();
            if (!(typeof company === 'undefined')) {
              _context3.next = 9;
              break;
            }
            $('.company-name-full', $view).html('N/A');
            $('.company-number', $view).html('N/A');
            $('.company-address', $view).html('N/A');
            _context3.next = 26;
            break;
          case 9:
            self = this;
            $('.company-name-full', $view).html(company.title);
            $('.company-number', $view).html(company.company_number);
            $('.company-address', $view).html(company.address_snippet);
            $('[data-href]', $view).toArray().forEach(function (e) {
              if ($(e).attr('data-type') === 'url') {
                var companyName = clientData.queryString.company.toLowerCase().replace(/[^a-z0-9 ]/g, "").replace(/\s/g, "-");
                $(e).attr('href', $(e).attr('data-href') + company.company_number + '-' + companyName + '/');
              } else {
                $(e).attr('href', $(e).attr('data-href') + '?company=' + company.company_number);
              }
            });

            // other company name in the dom
            $('.company-name-full').html(company.title);
            _context3.next = 17;
            return self.loadCompanyData(company.company_number);
          case 17:
            data = _context3.sent;
            timestampNextConf = new Date(data.confirmation_statement.next_due).getTime() / 1000 - 14 * 24 * 60 * 60;
            timestampToday = new Date().getTime() / 1000;
            if (!(clientData.origin === 'hybridMail' && (_clientData$formData8 = clientData.formData) !== null && _clientData$formData8 !== void 0 && (_clientData$formData8 = _clientData$formData8.type) !== null && _clientData$formData8 !== void 0 && _clientData$formData8.includes('/confirmationStatement') && timestampToday < timestampNextConf)) {
              _context3.next = 24;
              break;
            }
            window.location = LSUtils.url() + '/company/management/confirmationStatement/up-to-date/?company=' + data.company_number;
            _context3.next = 26;
            break;
          case 24:
            _context3.next = 26;
            return self.renderCompanyProfile($view, data);
          case 26:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function loadCompanyProfile(_x3, _x4) {
      return _loadCompanyProfile.apply(this, arguments);
    }
    return loadCompanyProfile;
  }(),
  loadCompanyData: function loadCompanyData(company_number) {
    var _clientData;
    var dfd = $.Deferred();
    $.ajax({
      url: LSUtils.url() + '/app/services/companyHouseJSON',
      data: {
        cmd: 'companyProfile',
        param: company_number,
        clientId: typeof ((_clientData = clientData) === null || _clientData === void 0 ? void 0 : _clientData.clientId) !== 'undefined' ? clientData.clientId : null,
        useStreamingApi: true
      },
      success: function success(response) {
        try {
          var data = JSON.parse(response).data;
          if (data) dfd.resolve(data);
        } catch (ex) {}
      }
    });
    return dfd.promise();
  },
  loadFilingsData: function loadFilingsData(company_number) {
    var dfd = $.Deferred();
    $.ajax({
      url: LSUtils.url() + '/app/services/companyHouseJSON',
      data: {
        cmd: 'companyProfile',
        param: company_number,
        filings: true
      },
      success: function success(response) {
        try {
          var data = JSON.parse(response).data;
          if (data) dfd.resolve(data);
        } catch (ex) {}
      }
    });
    return dfd.promise();
  },
  renderCompanyProfile: function () {
    var _renderCompanyProfile = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4($view, data) {
      var _data$confirmation_st, _data$officers, _data$accounts;
      var incorpDate, _clientData$formData9, date, timestampNextConf, timestampToday, longDate, confPill, directorsString, _data$accounts2, _data$accounts3, _data$accounts4, _clientData$formData11, acDueDate, tsNextAc, tsToday, _data$accounts5, accPill;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (data !== null && data !== void 0 && data.date_of_creation) {
              incorpDate = new Date(data === null || data === void 0 ? void 0 : data.date_of_creation).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
              });
              data['incorpDate'] = incorpDate;
            }
            if ((_data$confirmation_st = data.confirmation_statement) !== null && _data$confirmation_st !== void 0 && _data$confirmation_st.next_due) {
              date = new Date(data.confirmation_statement.next_due).toLocaleDateString('en-GB');
              timestampNextConf = new Date(data.confirmation_statement.next_due).getTime() / 1000;
              timestampToday = new Date().getTime() / 1000;
              longDate = new Date(data.confirmation_statement.next_due).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
              }).replace(/,/g, '');
              $('.confirmation-statement', $view).html(data.confirmation_statement ? date : 'N/A');
              $('.conf-stmnt-long', $view).html(data.confirmation_statement ? longDate : 'N/A');
              if ((_clientData$formData9 = clientData.formData) !== null && _clientData$formData9 !== void 0 && (_clientData$formData9 = _clientData$formData9.type) !== null && _clientData$formData9 !== void 0 && _clientData$formData9.includes('dormantAccounts')) {
                $('.confirmation-statement').html(data.confirmation_statement ? date : 'N/A');
              }
              confPill = "";
              if (timestampNextConf - timestampToday < 0) {
                $('.text-pill-danger', $view).show();
                $('.info-danger', $view).show();
                confPill = "<sup class='text-pill-danger' >Overdue</sup>";
              } else if (timestampNextConf - timestampToday < 30 * 24 * 60 * 60) {
                $('.text-pill-warning', $view).show();
                $('.info-warning', $view).show();
                confPill = "<sup class='text-pill-warning' >Due Soon</sup>";
              }
              data['confStatmentDue'] = longDate;
              data['confPill'] = confPill;
            } else {
              $('.confirmation-statement', $view).html('N/A');
              $('.conf-stmnt-long', $view).html('N/A');
            }
            if ((_data$officers = data.officers) !== null && _data$officers !== void 0 && (_data$officers = _data$officers.items) !== null && _data$officers !== void 0 && _data$officers.length) {
              directorsString = "";
              $('.officers', $view).html(data.officers.items.reduce(function (acc, val, i) {
                directorsString = i < 3 ? !val.resigned_on && val.officer_role === 'director' ? acc + val.name + (i < 2 && i < data.officers.items.length - 1 ? ' - ' : '') : acc : acc;
                return directorsString;
              }, ''));
              if (directorsString.endsWith(' - ')) {
                // Remove the last 3 characters and replace with ellipse
                directorsString = directorsString.slice(0, -3);
              }
              data['directorsString'] = directorsString;
            } else {
              $('.officers', $view).html('N/A');
            }
            data['sicCodes'] = "";
            if (data.company_status !== 'active') {
              $('.fa-dot-circle', $view).removeClass('text-success').addClass('text-danger');
              $('.activity', $view).html('N/A');
              data['sicCodes'] = "N/A";
            } else {
              // load and render sic code label
              $.ajax({
                url: LSUtils.url() + '/app/services/entities/sicCodes',
                data: {
                  address: '54.36.164.103',
                  where: encodeURIComponent(data.sic_codes[0] + ">=this.start && " + data.sic_codes[0] + "<=this.end")
                },
                success: function success(response) {
                  response = JSON.parse(response);
                  if (response.data && response.data.length) {
                    response.data[0].codesArr.forEach(function (e) {
                      if (e.value === data.sic_codes[1] || e.value === data.sic_codes[2]) {
                        data['sicCodes'] += ", ".concat(e.label);
                      }
                      if (e.value === data.sic_codes[0]) {
                        $('.activity', $view).html(e.label);
                        data['sicCodes'] += e.label;
                        if (e.value !== "74990" && e.value !== "99999") {
                          var _clientData$formData10;
                          if ((_clientData$formData10 = clientData.formData) !== null && _clientData$formData10 !== void 0 && (_clientData$formData10 = _clientData$formData10.type) !== null && _clientData$formData10 !== void 0 && _clientData$formData10.includes('dormantAccounts')) {
                            var updateDisclaimer = function updateDisclaimer() {
                              var tooltip = '<p>A ‘significant’ accounting transaction is defined as one that the company should enter in its accounting records. <b>It doesn’t matter how big or small the transaction actually is.</b> If any transaction(s) took place, the company will lose its dormant status.</p><p>There are only three transactions that do not qualify as \'significant\':<ul><li>- Payment for shares issued at the time of incorporation</li><li>- Any filing fees paid to Companies House, e.g. confirmation statement</li><li>- Any penalties for the late filing</li></ul></p>';
                              var $disclaimer = $('<div class="alert alert-danger text-sm" style="line-height: 18px;">' + '   <p>' + '       ❌&nbsp;&nbsp;It appears ' + '       <b>' + data.company_name + ' is not dormant</b>.' + '       As per the Companies House register its business activity is listed as:<br/><br/>' + e.label + '   </p> ' + '   <p>' + '       You can file dormant accounts only if you confirm that ' + data.company_name + ' has never traded before and had ' + '       <span class="tooltip-text" data-trigger="focus" data-toggle="popover" data-content="' + tooltip + '"><b>no ' + '       significant transactions</b></span> during its most recent accounting period.' + '   </p>' + '   <p>Subject to Companies House workload, in rare occasion, Companies ' + '      House can take up to 2 working days to approve dormant accounts. ' + '      Online filings will take no responsibility if you submit your account ' + '      less than 3 working days prior to the due date and receive a late ' + '      filing penalty.' + '</p>' + '</div>');
                              $('.cart .dormant-accounts-description .alert-warning').replaceWith($disclaimer);
                            };
                            updateDisclaimer();
                            LSCart.onRenderEvents.push(updateDisclaimer);
                          }
                        }
                      }
                    });
                  } else {
                    data['sicCodes'] = "dormant";
                    $('.activity', $view).html('dormant');
                    $('.fa-dot-circle', $view).removeClass('text-success').addClass('text-warning');
                  }
                }
              });
            }
            if ((_data$accounts = data.accounts) !== null && _data$accounts !== void 0 && _data$accounts.next_due) {
              acDueDate = new Date((_data$accounts2 = data.accounts) === null || _data$accounts2 === void 0 ? void 0 : _data$accounts2.next_due).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
              });
              tsNextAc = new Date((_data$accounts3 = data.accounts) === null || _data$accounts3 === void 0 ? void 0 : _data$accounts3.next_due).getTime() / 1000;
              tsToday = new Date().getTime() / 1000;
              $('.accounts', $view).html((_data$accounts4 = data.accounts) !== null && _data$accounts4 !== void 0 && _data$accounts4.next_due ? acDueDate : 'N/A');
              if ((_clientData$formData11 = clientData.formData) !== null && _clientData$formData11 !== void 0 && (_clientData$formData11 = _clientData$formData11.type) !== null && _clientData$formData11 !== void 0 && _clientData$formData11.includes('dormantAccounts')) {
                $('.accounts', $view).html((_data$accounts5 = data.accounts) !== null && _data$accounts5 !== void 0 && _data$accounts5.next_due ? acDueDate : 'N/A');
              }
              accPill = "";
              if (tsNextAc - tsToday < 0) {
                $('.accounts-item .text-pill-danger', $view).show();
                accPill = "<sup class='text-pill-danger' >Overdue</sup>";
              } else if (tsNextAc - tsToday < 365 / 4 * 24 * 60 * 60) {
                $('.accounts-item .text-pill-warning', $view).show();
                accPill = "<sup class='text-pill-warning' >Due Soon</sup>";
              }
              data['acDueDate'] = acDueDate;
              data['accPill'] = accPill;
            } else {
              $(".accounts", $view).html("N/A");
            }
            if (!$('#details-list', $view)) {
              _context4.next = 19;
              break;
            }
            _context4.next = 9;
            return LSUtils.sleep(1000);
          case 9:
            $('.company-id-header-loader').hide();
            $('.company-id-header').show();
            _context4.next = 13;
            return LSUtils.sleep(2000);
          case 13:
            if (typeof generateCompanyDetailsArray === 'function') generateCompanyDetailsArray(data, $view);
            $('.list-loader').hide();
            _context4.next = 17;
            return LSUtils.sleep(1000);
          case 17:
            $('.verified-label').hide();
            $('.verified-img').show();
          case 19:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function renderCompanyProfile(_x5, _x6) {
      return _renderCompanyProfile.apply(this, arguments);
    }
    return renderCompanyProfile;
  }(),
  renderSoleTrader: function renderSoleTrader($view) {
    $view.empty().html('<div class="title-md bold ellipsis company-name-full">Business type: soletrader</div>');
  },
  renderSearchResultsItems: function renderSearchResultsItems(chSearch) {
    var $res = $('<div></div>');
    chSearch.items.forEach(function (co, i) {
      var $tplItem = $('.templates .search-results-item').clone(true);
      var urlCoName = co.title.toLowerCase().replace(/[^a-z0-9 ]/g, '').replace(/ +/g, '-');
      var fullUrlPath = '/company/profile/' + co.company_number + '-' + urlCoName + '/';
      if (co.company_status === 'dissolved') {
        co.title += ' <small class="text-sm" style="color: black;">(dissolved)</small>';
        $('.link-checkout', $tplItem).addClass('disabled');
      }
      $('.link-profile span', $tplItem).text(LSUtils.url() + fullUrlPath);
      $('.link-profile', $tplItem).attr('href', LSUtils.url() + fullUrlPath);
      $('.link-checkout', $tplItem).attr('href', $('.link-checkout', $tplItem).attr('href') + co.company_number);
      $('.company-name', $tplItem).html(co.title);
      $('.company-number', $tplItem).html(co.company_number);
      $('.incorporation-date', $tplItem).html(co.description);
      $('.company-address', $tplItem).html(co.address_snippet);
      $res.append($tplItem);
    });
    return $res;
  },
  extractCoNumberFromNameCheckResponse: function extractCoNumberFromNameCheckResponse($html) {
    var $firstResult = $($('li', $html)[0]);
    var name = $('h3', $firstResult).text().trim();
    var content = $('p', $firstResult).text().trim();
    var number = content.substring(0, content.indexOf(' '));
    return number;
  },
  cleanCoName: function cleanCoName(coName) {
    var pattern = /[^-,.:; 0-9A-Z&@$£¥€'«»‘’“”?!()\[\]{}<>*=#%+ÀÁÂÃÄÅĀĂĄÆǼÇĆĈĊČÞĎÐÈÉÊËĒĔĖĘĚĜĞĠĢĤĦÌÍÎÏĨĪĬĮİĴĶĹĻĽĿŁÑŃŅŇŊÒÓÔÕÖØŌŎŐǾŒŔŖŘŚŜŞŠŢŤŦÙÚÛÜŨŪŬŮŰŲŴẀẂẄỲÝŶŸŹŻŽàáâãäåāăąæǽçćĉċčþďðèéêëēĕėęěĝğġģĥħìíîïĩīĭįi̇ĵķĺļľŀłñńņňŋòóôõöøōŏőǿœŕŗřśŝşšţťŧùúûüũūŭůűųŵẁẃẅỳýŷÿźżža-zÀÖØſƒǺǿẀẅỲỳ]*/g;
    // const pattern = /[^A-Z]/g;
    var res = coName.replace(pattern, '').replace(/  /g, ' ').trim();
    return res;
  },
  // SEARCH MODALS HELPERS

  renderSearchResults: function renderSearchResults(json, popupCallback) {
    var $res = $('<div>' + '   <h3 class="title-sm bold" style="text-align: center;margin-bottom: 30px !important;margin-top: -20px !important;">' + '       We found multiple matches...<br />' + '       <small class="text-md" style="font-weight: normal;">Click on the company you are looking for:</small>' + '   </h3>' + '</div>');
    json.items.forEach(function (item) {
      var $panel = $('<a data-company-number="' + item.company_number + '" href="#">' + '   <div class="card mb-3 bg-gray">' + '       <div class="card-body row" style="padding: 14px;">' + '           <div class="col-2 text-right" style="padding: 5px;">' + '               <i class="fa fa-building title-lg" style="color: lightgrey;margin: auto;"></i>' + '           </div>' + '           <div class="col-10">' + '           </div>' + '       </div>' + '   </div>' + '</a>');
      $res.append($($panel));
      var $panelbody = $('.col-10', $panel);
      $panelbody.append('<div class="text-md bold ellipsis">' + item.title + '</div>');
      $panelbody.append('<span class="text-sm" style="color: black;text-decoration: none !important;">' + item.description + '</span><br />');
      $panelbody.append('<span class="text-sm" style="color: black;text-decoration: none !important;">' + item.address_snippet + '</span>');
    });
    var self = this;
    $('[data-company-number]', $res).bind('click', function () {
      var companyNumber = $(this).attr('data-company-number');
      var companyData = json.items.find(function (i) {
        return i.company_number === companyNumber;
      });
      var $view = $('.company-id');
      self.loadCompanyProfile($view, companyData);
      self.popup.close();
      if (popupCallback && typeof popupCallback === 'function') {
        popupCallback();
      }
      return false;
    });
    return $res;
  },
  showSearchInput: function showSearchInput(companyName) {
    var self = this;
    var str = companyName ? 'The following company name or number was <b>not found</b> <br class="hidden-xs" />on the Companies House register:' : 'Missing company name';
    var $search = $('<div style="padding: 0 20px;">' + '   <div class="alert alert-warning">' + '       <i class="fa fa-exclamation-circle" style="color: orange"></i> ' + str + '   </div>' + '   <h2>' + companyName + '</h2>' + '   <div class="search-ctrls"></div>' + '   <br />' + '   <br />' + '</div>');
    var label = companyName ? 'Please search a different name' : 'Find your company by name';
    var placeholder = companyName ? 'Search a different name' : 'My company name';
    var $searchCtrls = $('<form class="form-ch-search needs-validation" novalidate action="#">' + '<div class="input-group mb-2 mt-1">' + '   <label for="input-search" class="text-md">' + '      <span class="search-company-name bold">' + label + ':</span>' + '   </label>' + '   <input id="input-search" name="company" type="text" class="form-control text-md input-sm"' + '       placeholder="' + placeholder + '...">' + '   <div class="input-group-append">' + '       <button type="submit" class="btn btn-success text-md btn-sm" style="margin-top: 5px;">' + '           <i class="fa fa-search"></i> Search' + '       </button>' + '   </div>' + '</div>' + '</form>');
    $('.search-ctrls', $search).append($searchCtrls);
    self.popup = BootstrapDialog.show({
      closable: false,
      fullscreen: false,
      title: 'Company not found',
      message: $search
    });
  },
  // checkout helpers

  saveBusinessType: function saveBusinessType(isSoleT) {
    var _clientData$formData12;
    $.ajax({
      url: LSUtils.url() + '/app/services/customer?clientId=' + clientData.clientId,
      type: 'POST',
      data: JSON.stringify({
        formData: {
          type: (_clientData$formData12 = clientData.formData) === null || _clientData$formData12 === void 0 ? void 0 : _clientData$formData12.type,
          isSoleTrader: isSoleT
        }
      })
    });
  },
  onSearchPageError: function onSearchPageError(companyName, searchResponse) {
    var _searchResponse;
    var self = this;
    var str = 'An error occurred while searching the following name on the Companies House register';
    var $search = $('<div style="padding: 0 20px;">' + '   <div class="alert alert-danger">' + '       <i class="fa fa-exclamation-triangle" style="color: red"></i> ' + str + '   </div>' + '   <h2>' + companyName + '</h2>' + '   <div class="search-ctrls"></div>' + '   <br />' + '   <br />' + '</div>');
    var $searchCtrls = $('<form class="form-ch-search needs-validation" novalidate action="#">' + '<div class="input-group mb-2 mt-1">' + '   <label for="input-search" class="text-md">' + '      <span class="search-company-name bold">Please search again:</span>' + '   </label>' + '   <input id="input-search" name="company" type="text" class="form-control text-md input-sm"' + '       placeholder="Search a different name..." value="' + companyName + '">' + '   <div class="input-group-append">' + '       <button type="submit" class="btn btn-primary text-md btn-sm">' + '           <i class="fa fa-search"></i> Search' + '       </button>' + '   </div>' + '</div>' + '</form>');
    $('.search-ctrls', $search).append($searchCtrls);
    self.popup = BootstrapDialog.show({
      closable: false,
      fullscreen: false,
      title: 'Search error',
      message: $search
    });
    if ((_searchResponse = searchResponse) !== null && _searchResponse !== void 0 && _searchResponse.data) searchResponse = searchResponse.data;
    var err = new Error('Search query: ' + companyName + ' - Search response: ' + JSON.stringify(searchResponse));
    try {
      var _newrelic;
      (_newrelic = newrelic) === null || _newrelic === void 0 || _newrelic.noticeError(err);
    } catch (ex) {
      throw err;
    }
  },
  showNameAvailModalContent: function showNameAvailModalContent(redirect, qs) {
    var $searchCtrls = $('<div class="text-center">' + '   <p class="text-lg mb-4 bold">To get started, check if your company name is available:</p>' + '   <div class="form-group cta input-group mt-0 mb-4 pb-0" style="max-width: 600px;margin: auto;">' + '       <label class="title-xs btn-search-label" style="margin-top: 8px;line-height: 24px">' + '           <input type="text" name="company" id="company" class="form-control title-sm" required' + '                   placeholder="Your dream company name" style="height: 50px;">' + '           <button type="submit" id="name-search-btn" data-size="s" class="btn btn-primary text-md h-100"><i' + '                   class="fa fa-search"></i> <span>Search Name</span>' + '           </button>' + '       </label>' + '       <div class="sensitive-word-error"></div>' + '       <div class="w-100 text-right mt-2">' + '           <div id="search-error" class="p-1 text-xs text-danger" style="display: none;">Error</div>' + '       </div>' + '   </div>' + '</div>');
    var $avail = $('<div>' + '   <div class="text-center">' + '      <h2 class="text-xl mt-0 pt-0">🎉 Great News!</h2>' + '       <div class="text-lg mb-4 bold mt-0"><span class="text-success company-name"></span><br />is available to register today</div>' + '   </div>' + '   <div class="w-100">' + '       <div class="float-right">' + '           <a id="try-again" href="#" class="text-sm d-inline mr-4 pt-1"><i class="fa fa-angle-left"></i> Search again</a>' + '           <button id="confirm-name" class=" d-inline m-2 btn btn-success btn-md text-sm" style="width: 220px;">Continue <i class="fa fa-angle-right"></i></button>' + '       </div>' + '   </div>' + '</div>');
    var $taken = $('<div class="mb-3" style="max-width: 480px;margin: auto;">' + '   <hr class="mt-2 mb-2" />' + '   <div class="text-lg mb-4 bold mt-0">😢 Sorry,<br /><span class="text-danger company-name"></span> is currently taken by an active company.</div>' + '   <div>' + '       <ul style="padding-left: 0;">' + '           <p class="text-md mb-2">How to choose a suitable company name:</p>' + '           <li class="text-md cta-item ellipsis m-0">' + '               <i class="fas fa-check-circle text-success"></i>' + '               Don\'t pick a name that\'s too similar to a competitor\'s name.' + '           </li>' + '               <li class="text-md cta-item ellipsis m-0">' + '              <i class="fas fa-check-circle text-success"></i>' + '               Choose a name that people can spell and pronounce.' + '           </li>' + '           <li class="text-md cta-item ellipsis m-0">' + '               <i class="fas fa-check-circle text-success"></i>' + '               Pick a name that\'s consistent with your brand and values.' + '           </li>' + '       </ul>' + '   </div>' + '</div>');
    var $notAvail = $('<div>' + '   <h3><b>🥲 We’re sorry, but that name is already taken</b></h3>' + '   <div class="text-md">Much like website domain names, company names need to be unique. Try again to see if it’s free</div>' + '   <div class="float-right p-4 mt-5">' + '       <a id="try-again" class="m-2" style="cursor: pointer;">Try another name?</a>' + '   </div>' + '</div>');
    var $msg = $('<div class="m-2">' + '   <div class="search-ctrls" style="display: block;"></div>' + '   <div class="search-name-avail" style="display: none;"></div>' + '   <div class="search-name-taken" style="display: none;"></div>' + '</div>');
    var btnLadda = Ladda.create($('button', $searchCtrls)[0]);
    var search = function search() {
      $('#search-error', $msg).css('display', 'none');
      $('.search-name-taken').css('display', 'none');
      var name = $("#company", $msg).val();
      if (!name) {
        $('#search-error', $msg).text('Please enter a company name, to check its availability.');
        $('#search-error', $msg).css('display', 'block');
        return;
      }
      btnLadda.start();
      $.ajax({
        url: LSUtils.url() + "/app/services/companyHouseJSON",
        data: {
          cmd: 'nameCheck',
          param: encodeURIComponent(name),
          clientId: clientData.clientId
        },
        success: function success(res) {
          btnLadda.stop();
          var valid = JSON.parse(res).data.validation;
          if (valid === "true") {
            $('.search-ctrls').css('display', 'none');
            $('.search-name-avail .company-name').text(name);
            $('.search-name-avail').css('display', 'block');
          } else {
            // $('#search-error', $msg).html('<b>' + name + '</b> is not available.');
            $('.search-name-taken .company-name').text(name);
            $('.search-name-taken', $msg).css('display', 'block');
            return;
          }
        }
      });
    };
    $('.search-ctrls', $msg).append($searchCtrls);
    $('.search-name-avail', $msg).append($avail);
    $('.search-name-taken', $msg).append($taken);
    $('#company', $msg).bind('keypress', function (e) {
      if (e.which === 13) search();
    });
    $('[type="submit"]', $msg).bind("click", search);
    $('#try-again', $msg).bind('click', function () {
      $('input', $msg).val('');
      $('.search-ctrls').css('display', 'block');
      $('.search-name-avail').css('display', 'none');
      $('.search-name-taken').css('display', 'none');
      return false;
    });
    $('#confirm-name', $msg).bind('click', function () {
      console.log($('.search-name-avail .company-name').text());
      window.location.assign(LSUtils.url() + redirect + '?companyName=' + encodeURIComponent($('.search-name-avail .company-name').text()) + (qs ? qs : ''));
    });
    return $msg;
  }
};
$(function () {
  LSCHWeb.initialize();
});
export { LSCHWeb };